var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sitebuilder-element-container",style:(_vm.style),attrs:{"id":_vm.id,"element":"CheckoutComponent","data-hide-desktop":!_vm.internal_config.showDesktop,"data-hide-mobile":!_vm.internal_config.showMobile,"data-tag":_vm.dataTag}},[_c('div',{ref:"mountingPoint",staticClass:"s-checkout-widget pt-2",attrs:{"dir":_vm.dir()}})])
}
var staticRenderFns = []

export { render, staticRenderFns }